import styled from 'styled-components';

const LanguageImage = styled.img`
  display: inline-block;
  user-select: none;
`;

export default LanguageImage;



// WEBPACK FOOTER //
// ./src/blocks/Navigation/Languages/LanguageImage.jsx